'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var alignPositionLTR = [
// align to right
'tl-tr', 'bl-br',

// align to left
'tr-tl', 'br-bl'];

var alignPositionRTL = [
// align to left
'tr-tl', 'br-bl',

// align to right
'tl-tr', 'bl-br'];

var alignOffsetLTR = [{ x: -7, y: 5 }, // ok
{ x: -7, y: -5 }, // ok
{ x: 7, y: 5 }, // ok
{ x: 7, y: -5 // ok
}];
var alignOffsetRTL = [{ x: 7, y: 5 }, // ok
{ x: 7, y: -5 }, // ok
{ x: -7, y: 5 }, // ok
{ x: -7, y: -5 // ok
}];

exports.alignPositionLTR = alignPositionLTR;
exports.alignPositionRTL = alignPositionRTL;
exports.alignOffsetLTR = alignOffsetLTR;
exports.alignOffsetRTL = alignOffsetRTL;